export enum QuotationAreaType {
  Generic = "generic",
  Shipping = "shipping",
  Logistics = "logistics",
  Marine = "marine"
}